import Joi from 'joi-browser';
import regex from '../../../utilities/validateRegex';
import { DISPLAY_FLAG } from '../../../utilities/constants';

/**
 * 緊急連絡先更新用パラメータを作成する
 * @param {object} param:パラメータ作成元情報
 * @return {object} 更新パラメータ
 * */
const createUpdateUrgencyContactParam = param => {
  return { ...param };
};

/**
 * 続柄取得用のリクエストパラメタを作成する
 * @return {object} 取得用パラメータ
 * */
const createFetchRelationshipParam = () => {
  return { display_flag: DISPLAY_FLAG.use.id };
};

/**
 * バリデーション用のスキーマを作成する
 * @return {object} スキーマオブジェクト
 * */
const createValidateSchema = () => {
  return {
    worker_urgency_contact_addresses: Joi.object().keys({
      postal_code: Joi.string()
        .regex(regex.pattern.zip)
        .allow(null, ''),
      tel: Joi.string()
        .regex(regex.pattern.tel)
        .allow(null, ''),
    }),
  };
};

const createSafetyDocItemSchema = () => {
  const schema = {
    name: Joi.string().required(),
    relationship: Joi.string().required(),
    prefectures: Joi.string().required(),
    city_name: Joi.string().required(),
    address1: Joi.string().required(),
    address2: Joi.string().required(),
    tel: Joi.string()
      .regex(regex.pattern.tel)
      .required(),
  };
  return schema;
};

/**
 *
 * */
const UrgencyContactService = {
  createUpdateUrgencyContactParam,
  createFetchRelationshipParam,
  createValidateSchema,
  createSafetyDocItemSchema,
};

export default UrgencyContactService;



// WEBPACK FOOTER //
// ./src/services/workers/urgencyContact/UrgencyContactService.js